import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  withStyles, Card, CardContent, Typography, CardActions,
  Button, Radio, Dialog, DialogTitle, DialogContent,
  CardHeader, DialogContentText, DialogActions, Box,
} from '@material-ui/core';
// eslint-disable-next-line import/no-extraneous-dependencies
import { convert } from 'html-to-text';
// eslint-disable-next-line import/no-extraneous-dependencies
import parse from 'html-react-parser';

// #region css
const styles = (theme) => ({
  cardTitle: {
    borderBottom: 'solid rgba(0, 0, 0, 0.15) 0.5px',
    height: '50px',
    overflow: 'hidden',
  },
  content: {
    height: '100px',
  },
  dialog: {
    width: '60%',
  },
  textCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  phoneTextField: {
    width: '10ch',
    [theme.breakpoints.down('xs')]: {
      width: '75px',
    },
  },
  smallTextField: {
    width: '10ch',
    [theme.breakpoints.down('xs')]: {
      width: '80px',
    },
  },
  smallTextFieldDate: {
    width: '10ch',
    [theme.breakpoints.down('xs')]: {
      width: '70px',
    },
  },
  footer: {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'end',
  },
});
// #endregion

class MailTemplateCard extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  displayContent = (content) => {
    const text = convert(content);
    if (text.length < 100) return text;
    const dispText = text.substring(0, 100);
    return `${dispText}...`;
  }

  handleOpenDialog = () => {
    this.setState({ open: true });
  }

  handleCloseDialog = () => {
    this.setState({ open: false });
  }

  handleSelectTemplate = () => {
    this.props.onSelectTemplate(this.props.data);
  }

  parseContent = (content) => parse(content);

  render() {
    const {
      classes,
      data,
      checked,
    } = this.props;

    const {
      open,
    } = this.state;

    return (
      <>
        <Card className={classes.card} variant="outlined">
          <CardHeader
            className={classes.cardTitle}
            avatar={
              <Radio onChange={this.handleSelectTemplate} checked={checked} />
            }
            title={data.title}
            titleTypographyProps={{ variant: 'body1' }}
          />
          <CardContent>
            <Typography variant="h6" component="h3">
              {data.subject ? data.subject : '件名なし'}
            </Typography>
            <Box mb={1} />
            <Typography className={classes.content} variant="body2" component="p">
              {this.displayContent(data.content)}
            </Typography>
          </CardContent>
          <CardActions className={classes.footer}>
            <Button size="small" color="primary" onClick={this.handleOpenDialog}>詳細を見る</Button>
          </CardActions>
        </Card>
        <Dialog
          open={open}
          scroll="paper"
          onClose={this.handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
          fullWidth
        >
          <DialogTitle id="alert-dialog-title">
            {data.subject ? data.subject : '件名なし'}
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText id="alert-dialog-description">
              {this.parseContent(data.content)}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseDialog} autoFocus>
              閉じる
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default withStyles(styles)(withRouter((MailTemplateCard)));
